module.exports = __webpack_public_path__ + "img/village.a4dcb389.png";